import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { SearchView } from './search.view';

export const SearchRoutes = (): JSX.Element => {
  const flags = useFeatureFlag(['search-internal-notes-filters']);

  return (
    <Routes>
      <Route index element={<Navigate to="conversations" replace />} />

      {flags.searchInternalNotesFilters && (
        <Route
          path="notes"
          element={<Navigate to="/search/conversations" replace />}
        />
      )}

      <Route path=":scope" element={<SearchView />} />
    </Routes>
  );
};
